import React from "react";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

export const Wrapper = ({ children, mode, toggleColorMode }) => {
  return (
    <>
      <HeaderBar mode={mode} toggleColorMode={toggleColorMode} />
      <div>{children}</div>
      <Footer />
    </>
  );
};
